__turbopack_context__.v({
  "ProductHero": "Dhs-nG_ProductHero",
  "ProductHero__Col": "Dhs-nG_ProductHero__Col",
  "ProductHero__Col__Single": "Dhs-nG_ProductHero__Col__Single",
  "ProductHero__Container": "Dhs-nG_ProductHero__Container",
  "ProductHero__ImageWrapper": "Dhs-nG_ProductHero__ImageWrapper",
  "ProductHero__InfoText": "Dhs-nG_ProductHero__InfoText",
  "ProductHero__ModelText": "Dhs-nG_ProductHero__ModelText",
  "ProductHero__Row": "Dhs-nG_ProductHero__Row",
  "ProductHero__RowBottom": "Dhs-nG_ProductHero__RowBottom",
  "ProductHero__Tab": "Dhs-nG_ProductHero__Tab",
  "ProductHero__Tab--Active": "Dhs-nG_ProductHero__Tab--Active",
  "ProductHero__Tab--Single": "Dhs-nG_ProductHero__Tab--Single",
  "ProductHero__TabContainer": "Dhs-nG_ProductHero__TabContainer",
  "ProductHero__TabContent": "Dhs-nG_ProductHero__TabContent",
  "ProductHero__TabImageWrapper": "Dhs-nG_ProductHero__TabImageWrapper",
  "ProductHero__Text": "Dhs-nG_ProductHero__Text",
  "ProductHero__Title": "Dhs-nG_ProductHero__Title",
});
